import { Component, OnInit } from "@angular/core";
import { BaseComponent } from "../pages/base.component";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/services/common.service";
import { Router } from "@angular/router";
declare var $: any;
@Component({
  selector: "app-institute-dashboard",
  templateUrl: "./institute-dashboard.component.html",
  styleUrls: ["./institute-dashboard.component.css"],
})
export class InstituteDashboardComponent
  extends BaseComponent
  implements OnInit {
  dashboardDetails: any = "";
  listGrid: any[] = [];
  comments: any = "";
  rowData: any = "";
  tntName: any = "";
  notificationAlerts: any[];

  constructor(
    protected CommonService: CommonService,
    protected toastr: ToastrService,
    private router: Router
  ) {
    super(CommonService, toastr);
  }

  ngOnInit(): void {
    this.tntName = sessionStorage.getItem("tntName");
    this.LoadDBDitails();
    this.GetList();
    this.loadPendingNotificationAlerts();
  }

  GetList(){
    this.listGrid = [];
    this.activeSpinner();
    this.CommonService.postCall(`Dashboard/GetPendingNotificationTransferRequest`, {"TENANTCODE":this.TenantCode}).subscribe(
      (res: any) => {
        this.listGrid = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      }
    );
  }
  // GetList() {
  //   this.listGrid = [];
  //   this.activeSpinner();
  //   this.CommonService.postCall(`StudentTransferRequest/GetList`, {
  //     TNT_CODE: localStorage.getItem("TenantCode"),
  //   }).subscribe(
  //     (res: any) => {
  //       // if (res?.length) {
  //       const filtered = (res ?? []).filter((item: any) => {
  //         const value = item && item.IS_APPROVED;
  //         const createdOnTime =
  //           item && item.CREATED_ON ? new Date(item.CREATED_ON).getTime() : NaN;
  //         const isApprovedMatch =
  //           value === 0 || value === 3 || value === "0" || value === "3";
  //         const hasValidCreatedOn = Number.isFinite(createdOnTime);
  //         return isApprovedMatch && hasValidCreatedOn;
  //       });
  //       const sorted = filtered.slice().sort((a: any, b: any) => {
  //         const aTime =
  //           a && a.CREATED_ON ? new Date(a.CREATED_ON).getTime() : 0;
  //         const bTime =
  //           b && b.CREATED_ON ? new Date(b.CREATED_ON).getTime() : 0;
  //         return bTime - aTime;
  //       });
  //       this.listGrid = sorted.slice(0, 3);
  //       console.log(this.listGrid);
  //       // this.toastr.success(res.message);
  //       this.deactivateSpinner();
  //       // }
  //     },
  //     (e) => {
  //       this.deactivateSpinner();
  //     }
  //   );
  // }

  ApproveRej(obj: any, status: number = 1) {
    if (
      status == 1
        ? confirm("Are you sure you want to approve?")
        : confirm("Are you sure you want to Reject?")
    ) {
      if ((this.comments == "" || this.comments == null) && status == 2) {
        return this.toastr.warning("Please enter Comments");
      }
      this.activeSpinner();
      this.CommonService.postCall(`StudentTransferRequest/UpdateApprove`, {
        TRANSFERREQ_ID: obj?.TRANSFERREQ_ID,
        IS_APPROVED: status,
        COMMENTS: this.comments,
      }).subscribe(
        (res: any) => {
          this.toastr.success(
            status == 1 ? "Approved Successfully" : "Rejected Successfully"
          );
          if (status == 2) {
            $("#reject").modal("hide");
          }
          this.GetList();
          this.deactivateSpinner();
        },
        (e) => {
          this.toastr.error(e.error.message);
          this.deactivateSpinner();
        }
      );
    }
  }

  rejectreason(obj: any) {
    this.rowData = obj;
    $("#reject").modal("show");
  }

  async LoadDBDitails() {
    const decryptedValue: any = await this.CommonService.decryptAesGcm(
      localStorage.getItem("RoleId"),
      this.CommonService.secretKey
    );
    let roleId = decryptedValue;
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    this.dashboardDetails = "";
    let payLoad = {
      v_tnt_code: localStorage.getItem("TenantCode"),
      v_county_id: userData?.county_id,
      v_sub_county_id: userData?.subcounty_id,
      v_role_id: localStorage.getItem("RoleId"),
      v_schoollevel:localStorage.getItem("schoolLevelID"),
    };
    this.CommonService.postCall(
      `Dashboard/LoadCdeScdeAdminDashboard`,
      payLoad
    ).subscribe((res: any) => {
      this.dashboardDetails = res;
    });
  }
  navigateToLearner() {
    this.router.navigate(["/HOME/registration/userRegistration/64"]);
  }

  // navigationTLUrl() {
  //   // this.router.navigate([`/HOME/reports/learnersRegistrations/5134`]);
  //   this.router.navigate([`/HOME/registration/learnerAdmission/5147`]);
  // }
navigationTLUrl(statusName:number) {
  this.router.navigate(
    ['/HOME/registration/learnerAdmission/5147'],
    { queryParams: { status: statusName } }
  );
}

  navigationToReports() {
    this.router.navigate([`/HOME/reports/learnersRegistrations/5134`]);
  }
  navigationTTRUrl() {
    this.router.navigate([`/HOME/registration/schoolTransferApproval/5095`]);
  }
  loadPendingNotificationAlerts() {

    this.notificationAlerts = [];
    this.activeSpinner();
    this.CommonService.postCall(`Dashboard/GetLearnerTransferCount`, {
      TNT_CODE: localStorage.getItem("TenantCode"),
    }).subscribe(
      (res: any) => {
        this.notificationAlerts = res
        this.deactivateSpinner();
      }, (e) => {
        this.deactivateSpinner();
      });


  }
}
